import React from "react";
import Dashboard from "./Pages/EmployeeDashboard/dashboard";
import Personal from "./Pages/EmployeeDashboard/Personal/Personal";
import Job from "./Pages/EmployeeDashboard/Job/Job";
import Emergency from "./Pages/EmployeeDashboard/Emergency/Emergency";
import Documents from "./Pages/EmployeeDashboard/Documents/Documents";
import Assets from "./Pages/EmployeeDashboard/EmployeeAssets/EmployeeAssets";
import Attendance from "./Pages/EmployeeDashboard/EmployeeAttendence/EmployeeAttendence";
import Complaints from "./Pages/EmployeeDashboard/Complaints/Complaints";
import ExpenseManagement from "./Pages/EmployeeDashboard/ExpenseManagment/index";
import Compliance from "./Pages/EmployeeDashboard/Compliance/Compliance";
import { BarChartOutlined, CarryOutOutlined, CheckCircleOutlined, DashboardOutlined, ExclamationCircleOutlined, FileTextOutlined, FolderOpenOutlined, IdcardOutlined, ReadOutlined, SafetyCertificateOutlined, ScheduleOutlined, TeamOutlined, ToolOutlined, UsergroupDeleteOutlined, UserOutlined } from "@ant-design/icons";
import LeaveRequest from "./Pages/EmployeeDashboard/LeaveRequest/LeaveRequest";
import TeamLeaveApprovals from "./Pages/EmployeeDashboard/TeamLeaveApprovals/TeamLeaveApprovals";
import TeamAttendance from "./Pages/EmployeeDashboard/TeamAttendance/TeamAttendance";
import TrainingAndDevelopment from "./Pages/EmployeeDashboard/TrainingAndDevelopement/TrainingAndDevelopement";
import ExpenseManagementList from "./Pages/EmployeeDashboard/ManageExpenses/ExpenseManagment";
import EmployeePerformanceReview from "./Pages/EmployeeDashboard/PerformanceReview/EmployeePerformanceRvw";
import Employees from "./Pages/EmployeeDashboard/Employees/Employees";
import ExploreCareers from "./Pages/EmployeeDashboard/ExploreCareers/ExploreCareers";
import EmployeeMyCareerPath from "./Pages/EmployeeDashboard/CareerPath/EmployeeMyCareerPath";
import MyPayBonus from "./Pages/EmployeeDashboard/MyPayBonus/MyPayBonus";
import RecommendBonus from "./Pages/EmployeeDashboard/RecommendBonus/RecommendBonus";
import ExpensePaymentReport from "./Pages/EmployeeDashboard/ManageExpenses/ExpensePaymentReport";
import FlightRisk from "./Pages/EmployeeDashboard/FlightRisk/FlightRisk";
import { CompassOutlined, RocketOutlined, DollarOutlined, GiftOutlined, WalletOutlined, WarningOutlined } from "@ant-design/icons";

const routes = [
  {
    type: "collapse", // Use "route" instead of "collapse" for individual routes
    name: "Dashboard",
    key: "Employeedashboard",
    route: "/employeedashboard",
    icon: <DashboardOutlined size="16px" />,
    component: <Dashboard />, // Just reference the component, not JSX
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Personal",
    key: "personal",
    route: "/employeedashboard/personal",
    icon: <UserOutlined size="16px" />,
    component: <Personal />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Job",
    key: "jobemployee",
    route: "/employeedashboard/jobemployee",
    icon: <IdcardOutlined size="12px" />,
    component: <Job />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Compliance",
    key: "compliance",
    route: "/employeedashboard/compliance",
    icon: <SafetyCertificateOutlined size="12px" />,
    component: <Compliance />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Remote Attendance",
    key: "attendance",
    route: "/employeedashboard/attendance",
    icon: <CarryOutOutlined size="12px" />,
    component: <Attendance />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Leave Request",
    key: "leaverequest",
    route: "/employeedashboard/leave-request",
    icon: <FileTextOutlined size="12px" />,
    component: <LeaveRequest />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Team Leave Approvals",
    key: "team-leave-approvals",
    route: "/employeedashboard/team-leave-approvals",
    icon: <CheckCircleOutlined size="12px" />,
    component: <TeamLeaveApprovals />,
    managerOnly: true,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Team Attendance",
    key: "team-attendance",
    route: "/employeedashboard/team-attendance",
    icon: <ScheduleOutlined size="12px" />,
    component: <TeamAttendance />,
    managerOnly: true,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Recommend Bonus",
    key: "recommend-bonus",
    route: "/employeedashboard/recommend-bonus",
    icon: <GiftOutlined size="12px" />,
    component: <RecommendBonus />,
    managerOnly: true,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Flight Risk",
    key: "flight-risk",
    route: "/employeedashboard/flight-risk",
    icon: <WarningOutlined size="12px" />,
    component: <FlightRisk />,
    managerOnly: true,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training and Development",
    key: "training",
    route: "/employeedashboard/training",
    icon: <ReadOutlined size="12px" />,
    component: <TrainingAndDevelopment />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    route: "/employeedashboard/documents",
    icon: <FolderOpenOutlined size="12px" />,
    component: <Documents />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Emergency",
    key: "emergency",
    route: "/employeedashboard/emergency",
    icon: <ExclamationCircleOutlined size="12px" />,
    component: <Emergency />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Assets",
    key: "assets",
    route: "/employeedashboard/assets",
    icon: <ToolOutlined size="12px" />,
    component: <Assets />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Complaints",
    key: "complaints",
    route: "/employeedashboard/complaints",
    icon: <ExclamationCircleOutlined  size="12px" />,
    component: <Complaints />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Expenses",
    key: "expenseManagement",
    route: "/employeedashboard/expenseManagement",
    icon: <BarChartOutlined size="12px" />,
    component: <ExpenseManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Pay & Bonuses",
    key: "my-pay-bonuses",
    route: "/employeedashboard/my-pay-bonuses",
    icon: <DollarOutlined size="12px" />,
    component: <MyPayBonus />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Payments",
    key: "my-payments",
    route: "/employeedashboard/my-payments",
    icon: <WalletOutlined size="12px" />,
    component: <ExpensePaymentReport />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Employees",
    key: "employees",
    route: "/employeedashboard/employees",
    icon: <TeamOutlined size="12px" />,
    component: <Employees />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Explore Careers",
    key: "explore-careers",
    route: "/employeedashboard/explore-careers",
    icon: <CompassOutlined size="12px" />,
    component: <ExploreCareers />,
    noCollapse: true,
  },
  {
    // Per Mudassir May-20 doc: Employee Dashboard mirror of the HR-side
    // CareerPath view. Lands on "My Career Path" which also has a button
    // to navigate to the AI-powered Alternative Paths view.
    type: "collapse",
    name: "My Career Path",
    key: "my-career-path",
    route: "/employeedashboard/career-path",
    icon: <RocketOutlined size="12px" />,
    component: <EmployeeMyCareerPath />,
    noCollapse: true,
  },
  {
    type: "divider",
    key: "bottom-divider"
  },
  {
    type: "collapse",
    name: "Performance Review",
    key: "performance-review",
    route: "/employeedashboard/performance-review",
    icon: <TeamOutlined size="12px" />,
    component: <EmployeePerformanceReview/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage Expenses",
    key: "manage-expenses",
    route: "/employeedashboard/manage-expenses",
    icon: <BarChartOutlined  size="12px" />,
    component: <ExpenseManagementList />,
    noCollapse: true,
  },
  
    


];

export default routes;
